<template>
	<SecondaryButton @click="handleClick">
		{{ buttonText }}
	</SecondaryButton>
</template>

<script>
import { computed } from 'vue'
import { hideAllModals, hideAllOffcanvas, hideModal, hideOffcanvas } from '@/utils'
import SecondaryButton from '@/components/ui/buttons/variants/SecondaryButton.vue'

export default {
	name: 'DismissButton',
	components: { SecondaryButton },
	props: {
		isModal: {
			type: Boolean,
			default: true
		},
		modalId: {
			type: String,
			default: ''
		},
		contentBtnText: {
			type: String,
			default: ''
		},
		onClick: {
			type: Function,
			default: null
		}
	},
	setup(props) {
		const buttonText = computed(() => {
			// Si te pasan texto, lo usas; si no, fallback simple
			return props.contentBtnText || 'Cerrar'
		})

		return { buttonText }
	},
	methods: {
		handleClick() {
			if (this.onClick) this.onClick()

			if (this.isModal && this.modalId) hideModal(this.modalId)
			if (this.isModal && !this.modalId) hideAllModals()

			if (!this.isModal && this.modalId) hideOffcanvas(this.modalId)
			if (!this.isModal && !this.modalId) hideAllOffcanvas()
		}
	}
}
</script>
